import { escapeHtml } from './compose';
import { getInitials } from './avatar';

// E-posta imzaları: e-posta istemcileri için tablo tabanlı, satır içi stilli HTML üretir.
// Kullanıcının yazdığı her alan kaçışlanır; görsel/bağlantı adresleri yalnızca http(s) olabilir.

export const SIGNATURE_TEMPLATES = [
  { id: 'corporate', name: 'Kurumsal' },
  { id: 'minimal', name: 'Minimal' },
  { id: 'horizontal', name: 'Yatay' },
];

export const DEFAULT_ACCENT = '#1769D6';

export const emptyFields = (user) => ({
  name: user?.display_name || user?.email?.split('@')[0] || '',
  title: '',
  company: '',
  phone: '',
  email: user?.email || '',
  website: '',
  logoUrl: '',
  accent: DEFAULT_ACCENT,
});

const safeColor = (value) => (/^#[0-9a-fA-F]{6}$/.test(value || '') ? value : DEFAULT_ACCENT);
const safeHttpUrl = (value) => {
  const url = (value || '').trim();
  return /^https?:\/\/[^\s"'<>]+$/i.test(url) ? url : '';
};
const webHref = (value) => {
  const v = (value || '').trim();
  if (!v) return '';
  const withProtocol = /^https?:\/\//i.test(v) ? v : `https://${v}`;
  return safeHttpUrl(withProtocol);
};

const contactLines = (f, color) => {
  const lines = [];
  if (f.phone) lines.push(`<span style="color:${color};font-weight:600;">T</span>&nbsp; ${escapeHtml(f.phone)}`);
  if (f.email) lines.push(`<span style="color:${color};font-weight:600;">E</span>&nbsp; <a href="mailto:${escapeHtml(f.email)}" style="color:#1f2937;text-decoration:none;">${escapeHtml(f.email)}</a>`);
  const href = webHref(f.website);
  if (f.website) {
    const label = escapeHtml(f.website.replace(/^https?:\/\//i, ''));
    lines.push(`<span style="color:${color};font-weight:600;">W</span>&nbsp; ${href ? `<a href="${escapeHtml(href)}" style="color:${color};text-decoration:none;">${label}</a>` : label}`);
  }
  return lines;
};

const avatarCell = (f, color) => {
  const logo = safeHttpUrl(f.logoUrl);
  if (logo) {
    return `<td style="padding-right:14px;vertical-align:top;"><img src="${escapeHtml(logo)}" alt="" width="64" style="display:block;width:64px;height:auto;border:0;"></td>`;
  }
  const initials = escapeHtml(getInitials(f.name, f.email));
  return `<td style="padding-right:14px;vertical-align:top;"><div style="width:56px;height:56px;line-height:56px;border-radius:50%;background:#e5e7eb;color:#374151;font-weight:700;font-size:20px;text-align:center;">${initials}</div></td>`;
};

export const generateSignatureHtml = (templateId, fields) => {
  const f = { ...emptyFields(), ...fields };
  const color = safeColor(f.accent);
  const base = 'font-family:Arial,Helvetica,sans-serif;font-size:13px;line-height:1.5;color:#1f2937;';
  const name = `<div style="font-size:16px;font-weight:700;color:#111827;">${escapeHtml(f.name)}</div>`;
  const role = [f.title, f.company].filter(Boolean).map(escapeHtml);
  const lines = contactLines(f, color);

  if (templateId === 'minimal') {
    return `<table cellpadding="0" cellspacing="0" style="${base}"><tr><td>
${name}
${role.length ? `<div style="color:#6b7280;">${role.join(' | ')}</div>` : ''}
${lines.length ? `<div style="margin-top:8px;padding-top:8px;border-top:1px solid #e5e7eb;font-size:12px;color:#6b7280;">${lines.join(' &nbsp;•&nbsp; ')}</div>` : ''}
</td></tr></table>`;
  }

  if (templateId === 'horizontal') {
    return `<table cellpadding="0" cellspacing="0" style="${base}"><tr>
${avatarCell(f, color)}
<td style="vertical-align:middle;">
${name}
${role.length ? `<div style="color:${color};font-weight:600;">${role.join(' · ')}</div>` : ''}
${lines.length ? `<div style="margin-top:4px;font-size:12px;">${lines.join(' &nbsp;&nbsp; ')}</div>` : ''}
</td></tr></table>`;
  }

  // corporate (varsayılan): sol avatar + dikey vurgu çizgisi + bilgiler
  return `<table cellpadding="0" cellspacing="0" style="${base}"><tr>
${avatarCell(f, color)}
<td style="border-left:3px solid ${color};padding-left:14px;vertical-align:top;">
${name}
${f.title ? `<div style="color:#6b7280;">${escapeHtml(f.title)}</div>` : ''}
${f.company ? `<div style="color:${color};font-weight:600;">${escapeHtml(f.company)}</div>` : ''}
${lines.length ? `<div style="margin-top:6px;font-size:12px;">${lines.map((l) => `<div>${l}</div>`).join('')}</div>` : ''}
</td></tr></table>`;
};
